import { HighlightOff } from "@mui/icons-material";
import { StyledCloseButton } from "./styled";
import { IChatCloseButtonProps } from "./types";

const CloseButton = (props: IChatCloseButtonProps)=>{
    return (
        <StyledCloseButton onClick={props.onClick} size="medium">
            <HighlightOff fontSize="medium"/>
        </StyledCloseButton>
    )
}

export {CloseButton}